var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup90506(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.6,
    height: 20.447,
    viewBox: "0 0 31.6 20.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90506",
    "data-name": "Group 90506",
    transform: "translate(1487 23133.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-identity",
    className: "cls-1",
    d: "M21.4,8a3.812,3.812,0,0,0-2.28.678l-3.954,2.729H2.962A3.032,3.032,0,0,0,0,14.475v10.9a3.032,3.032,0,0,0,2.962,3.067H20.079a2.907,2.907,0,0,0,2.124-.941l.667.25-.039-.016a8.819,8.819,0,0,0,3.455.707h4.325a1,1,0,0,0,.987-1.022V15.5a1.035,1.035,0,0,0-.395-.817l-7.559-5.87h0A3.828,3.828,0,0,0,21.4,8Zm-.054,2.041a1.9,1.9,0,0,1,1.11.4l7.165,5.563V26.4H26.287a6.9,6.9,0,0,1-2.7-.552l-.039-.016-8.4-3.151h0a1.25,1.25,0,0,1-.711-1.563A1.191,1.191,0,0,1,15.9,20.3l.022.007L23.8,22.283a.965.965,0,0,0,.972-.271A1.048,1.048,0,0,0,25.006,21a1,1,0,0,0-.744-.7l-1.22-.306V14.475a3.032,3.032,0,0,0-2.962-3.067H18.732l1.489-1.028A1.888,1.888,0,0,1,21.351,10.042ZM2.962,13.452H15.336a.955.955,0,0,0,.251,0h4.493a.99.99,0,0,1,.987,1.022V19.5L16.4,18.328h0a3.18,3.18,0,0,0-3.839,2.143,3.346,3.346,0,0,0,1.875,4.119l.019.007L19.265,26.4H2.962a.99.99,0,0,1-.987-1.022v-10.9A.99.99,0,0,1,2.962,13.452ZM7.242,15.5a2.046,2.046,0,1,0,1.975,2.045A2.011,2.011,0,0,0,7.242,15.5ZM4.63,20.95a.692.692,0,0,0-.68.7v.635c0,1.083,1.334,2.069,3.292,2.069s3.292-.985,3.292-2.067v-.636a.692.692,0,0,0-.68-.7Z",
    transform: "translate(-1487 -23142)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup90506);
export default __webpack_public_path__ + "static/media/Group 90506.cebec69665b6ed9e616dffcc04be994b.svg";
export { ForwardRef as ReactComponent };